export default {"src":"/_next/static/media/prev-swiper.101e12d0.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};